const Events = {
  register: {
    ADD_DEPOSIT: 'register:account:add_deposit',
    ADD_DEPOSIT_REFUND: 'register:account:add_deposit_refund',
    PAYMENTS_START: 'payments:start',
    PAYMENTS_CLOSE: 'payments:close',
    PAYMENTS_FINISH: 'payments:finish',
    SALE_UPDATING: 'payments:sale:updating',
    SALE_UPDATED: 'payments:sale:updated',
    SHOW_PAYMENTS: 'payments:show',
    CONFIRM_FOR_UNSAVED_CHANGES: 'payments:sale:confirm:for:unsaved:changes',
    SHIPPING_UPDATED: 'payments:shipping:updated',
    DEPOSIT_REFUNDS_REQUESTED: 'payments:deposit:refunds:requested',
    PAYMENTS_USING_CREDIT_ACCOUNT: 'payments:credit:account:used',
    QUICK_CASH_PAY_REQUESTED: 'payments:quick:cash:pay:requested',
    QUICK_CARD_PAY_REQUESTED: 'payments:quick:card:pay:requested',
    PREAUTH_PAY_REQUESTED: 'payments:preauth:pay:requested',
    CANCEL_SALE_REQUESTED: 'payments:sale:cancel:requested',
    REGISTER_TIP_REASSIGN: 'payments:sale:tip:reassign:requested',
    GET_PENDING_PAYMENTS: 'payments:get:pending',
    ADD_INVOICING_DEPOSIT: 'register:account:add_invoicing_deposit',
    ADD_INVOICE_PAYMENT: 'register:account:add_invoice_payment',
    ADD_DEPOSIT_PAYMENT: 'register:account:add_deposit_payment',
    PREVIEW_INVOICE: 'register:account:preview_invoice',
  },
};

export default class GlobalEvents {
  static get Events() {
    return Events;
  }
}
